import type { ReactQueryOptions } from 'utils/trpc';
import { trpc } from 'utils/trpc';

export const useCheckDomain = (
  options?: ReactQueryOptions['saml']['checkDomain'],
) => {
  return trpc.saml.checkDomain.useMutation(options);
};
